import type { ProductPrices } from './product-prices';
import isSufficientlyDifferentPrice from '@spa/components/product-price/isSufficientlyDifferentPrice';

export interface StrikePriceInfo {
  readonly isUVP: boolean;
  readonly priceValue: number;
}

export interface PriceStrikeRules {
  findStrikePriceInfo(): StrikePriceInfo | undefined;
  getPriceValue(): number | undefined;
  isUVP(): boolean;
}

class BasePriceStrikeRules implements PriceStrikeRules {
  constructor(readonly prices: ProductPrices) {}
  public isUVP(): boolean {
    return false;
  }

  public getPriceValue(): number {
    return this.prices.currentPriceValue;
  }

  referencePrice = this.prices.campaignPriceValue ?? this.prices.currentPriceValue;
  priceValue = this.getPriceValue();

  public findStrikePriceInfo(): StrikePriceInfo | undefined {
    return isSufficientlyDifferentPrice(this.referencePrice, this.priceValue)
      ? { isUVP: this.isUVP(), priceValue: this.priceValue }
      : undefined;
  }
}

class CurrentPriceWORecommendedRetailPriceRules extends BasePriceStrikeRules {}

class StrikePriceWORecommendedRetailPriceRules extends BasePriceStrikeRules {
  public getPriceValue(): number {
    return this.prices.strikePriceValue ?? this.prices.currentPriceValue;
  }
}

class RecommendedRetailPriceRules extends BasePriceStrikeRules {
  isUVP(): boolean {
    return !!this.prices.recommendedRetailPriceValue;
  }

  public getPriceValue(): number {
    return (
      this.prices.recommendedRetailPriceValue ??
      this.prices.strikePriceValue ??
      this.prices.currentPriceValue
    );
  }
}

const strikeRulesFactory = (countryCode: string, prices: ProductPrices): PriceStrikeRules => {
  switch (countryCode) {
    case 'CH':
      return new CurrentPriceWORecommendedRetailPriceRules(prices);
    case 'HR':
    case 'HU':
    case 'SK':
    case 'SI':
      return new StrikePriceWORecommendedRetailPriceRules(prices);
    case 'AT':
    case 'DE':
    case 'ES':
      return new RecommendedRetailPriceRules(prices);
    default:
      return new BasePriceStrikeRules(prices);
  }
};

export default strikeRulesFactory;
